module.exports = __webpack_public_path__ + "assets/preview-article.e217cd5e.svg";